import React, { useCallback, useLayoutEffect, useState } from "react";
import { AXIOS_DELETE, AXIOS_POST, AXIOS_UPDATE } from "../../server/api/crud";
import DashboardDocumenten from "../../Componenten/DashboardDocumenten";
import UploadDocumenten from "../../Componenten/Calender/UploadDocumenten";
import FilterNavigation from "../../Componenten/Dashboard/FilterNavigation";
import { DocumentIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import FileCard from "../../Componenten/MiniCards/FileCard";
import Swal from "sweetalert2";
import { deleteObject, ref } from "firebase/storage";
import { storage } from "../../firebase/firebase";
import FileCardAdvies from "../../Componenten/MiniCards/FileCardAdvies";
import FileCardPlans from "../../Componenten/MiniCards/FileCardPlans";
import { useSelector } from "react-redux";
import { CheckIcon, XMarkIcon } from "@heroicons/react/20/solid";
import RP_Avatar from "../../Componenten/RP_Avatar";
import SelectDetailsPatient from "../../Componenten/SelectDetailsPatient";
import {
  fetchAllPatientenDetails,
  fetchAllUsersDetails,
} from "../../apiCalls/usersApi";
import SelectPatientPagination from "../../Componenten/SelectPatientPagination";
import { documentenKeuzen, sendEmailGewoon } from "../../function";
import { emailDocumentenUpload } from "../../EmailTemplates";

const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

const PlansAdmin = ({
  userdetails,
  attachments,
  setRefresh,
  setAttachments,
  type = "uploads",
}) => {
  const [open, setOpen] = useState(false);
  const [select, setSelect] = useState([]);
  const [patientenselect, setPatienten] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selectFilter, setselectFilter] = useState(2);
  const { patienten } = useSelector((state) => state.user);

  const handleChange = useCallback(
    async (p_id, e) => {
      if (!Array.isArray(select) || select.length === 0) return;

      const checks = e.target.checked;

      let title = checks
        ? `Wilt u deze patiënt rechten geven aan al deze ${select.length} bestanden?`
        : `Wilt u bij deze patiënt rechten afnemen voor al deze ${select.length} bestanden?`;

      const result = await Swal.fire({
        icon: "question",
        title: title,
        showCancelButton: true,
        confirmButtonText: "Ja",
        cancelButtonText: "Neen",
        confirmButtonColor: "#111827",
        cancelButtonColor: "green",
      });

      if (!result.isConfirmed) return;

      const batchSize = 3;

      const updateOneDocument = async (doc) => {
        const updatedUsers = checks
          ? [...(doc.users || []), p_id]
          : doc.users?.filter((user) => user !== p_id);

        const updatedDocument = { users: updatedUsers };

        console.log("Usersssss ==> ", doc);

        try {
          const resp = await AXIOS_UPDATE(
            `documents/admin`,
            doc.id,
            updatedDocument
          );

          if (resp.status === 200) {
            const klant = patientenselect?.find(
              (item) => item.user_id === p_id
            );

            // Update attachments state
            setAttachments((prev) =>
              prev.map((item) =>
                item.id === doc.id ? { ...item, users: updatedUsers } : item
              )
            );

            // Update select state
            if (checks) {
              setSelect((prev) =>
                prev.map((item) =>
                  item.id === doc.id ? { ...item, users: updatedUsers } : item
                )
              );
            } else {
              setSelect([]);
            }

            return {
              success: true,
              message: `Bestand: ${doc.bestand} is nu zichtbaar voor ${klant?.full_name}`,
            };
          } else {
            return {
              success: false,
              message: `Fout bij opslaan: ${doc.bestand}`,
            };
          }
        } catch (error) {
          console.error(`Error updating document ${doc.id}:`, error);
          return {
            success: false,
            message: `Fout bij het updaten van bestand: ${doc.bestand}`,
          };
        }
      };

      for (let i = 0; i < select.length; i += batchSize) {
        const batch = select.slice(i, i + batchSize);

        // Show progress before sending the batch
        /* Swal.fire({
          title: `Opslaan (${i + 1} - ${Math.min(i + batchSize, select.length)} van ${select.length})...`,
          didOpen: () => Swal.showLoading(),
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
        });*/

        const results = await Promise.all(batch.map(updateOneDocument));

        // Optional: Log or display batch results
        results.forEach((res) => {
          if (!res.success) console.warn(res.message);
        });
      }

      const recipient = patienten.find((el) => el?.user_id == p_id);

      const pagina = documentenKeuzen(1)['plans'];

      if (recipient) {
        const emailData = {
          from_name: "RepeatConnect",
          receiver: recipient.full_name,
          sender_email: "info@repeathealth.com",
          title: `Hallo ${recipient.full_name}, Er werden nieuwe documenten aan uw Mealplans/Voedingsmiddelentabel/Recepten`,
          receiver_email: recipient.email,
          object: pagina,
          name: userdetails?.full_name,
          bericht: "documenten",
          inloglink: "https://repeatconnect.com",
        };

        const emailHtml = emailDocumentenUpload(emailData);

        sendEmailGewoon("template_qdoh9mv", {
        message_html: emailHtml,
        title: emailData.title,
        receiver_email: emailData.receiver_email,
      });
      }

      Swal.close();
      Swal.fire(
        "Klaar!",
        "Alle geselecteerde bestanden zijn bijgewerkt.",
        "success"
      );
      setSelect([]);

    },
    [select, patientenselect]
  );

  const deleteDocument = async (item) => {
    const result = await Swal.fire({
      title: "Bent u zeker deze document te willen verwijderen",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Ja",
      denyButtonText: "Neen",
      confirmButtonColor: "red",
      denyButtonColor: "gray",
    });

    const id = item.id;
    if (result.isConfirmed) {
      await AXIOS_DELETE("documents/admin", id)
        .then((result) => {
          if (result.status === 200) {
            // Create a reference to the file to delete
            const fileRef = ref(storage, item?.url);

            // Delete the file from Firebase Storage
            deleteObject(fileRef);
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: `Bestand is goed verwijderd`,
              showConfirmButton: false,
              timer: 2500,
            });

            setRefresh(true);
          }
        })
        .catch((e) => {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `er is iets mis gelopen`,
            showConfirmButton: false,
            timer: 2500,
          });
        });
    }
  };

  function addItem(item) {
    setSelect((prev) => {
      // Check if any existing element has the same id
      const exists = prev.some((el) => el?.id === item?.id);
      if (exists) {
        return prev.filter((el) => el?.id != item?.id); // No change if already in the array
      }
      return [...prev, item];
    });
  }

  useLayoutEffect(() => {
    if (userdetails) {
      const { user_id } = userdetails;
      fetchAllPatientenDetails(4, 0, "", setLoading, setError, setPatienten);
      //Redirect to home page if user is already logged in
    }
  }, []);

  const checkedHasUSers = (patient) => {
    const count = select.filter((el) =>
      el?.users?.includes(patient?.user_id)
    ).length;
    return select.length == count && select?.length > 0;
  };

  return (
    <div className="mx-auto w-full h-max bg-white dark:bg-gray-800">
      <div className="flex justify-between gap-x-8">
        <SelectPatientPagination
          data={patientenselect}
          setData={setPatienten}
          setLoading={setLoading}
          setError={setError}
        />
      </div>
      <div className=" flex px-2">
        <div className="w-4/6">
          <div className="px-3">
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="block rounded-md bg-green-800 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
            >
              Voeg een document toe
            </button>
            <div className="col-span-2 grid grid-cols-2 gap-2 mt-4">
              {attachments?.length > 0 ? (
                attachments.map((item) => (
                  <div
                    onClick={() => addItem(item)}
                    className={classNames(
                      "rounded ",
                      select.some((el) => el?.id === item?.id)
                        ? "dark:bg-green-800 ring-2 bg-green-50 ring-green-500 dark:ring-green-700"
                        : "dark:bg-gray-800 ring-1 ring-gray-300 dark:ring-gray-700"
                    )}
                  >
                    <FileCardAdvies
                      item={item}
                      deleteDocument={deleteDocument}
                      userdetails={userdetails}
                    />
                  </div>
                ))
              ) : (
                <div className="text-center p-8 dark:bg-gray-800 w-full dark:text-white bg-gray-100  border-gray-300 w-full grid grid-cols-1">
                  <p>Er zijn adviezen documenten gevonden</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="w-2/6 h-full dark:border-gray-700  shadow  rounded dark:bg-gray-800">
          <div className="grid grid-cols-2 gap-2 m-4 justify-items-center">
            {patientenselect?.length > 0 &&
              patientenselect.map((patient) => (
                <div
                  className="dark:bg-gray-700 p-2 w-full rounded border relative cursor-pointer"
                  title={patient?.full_name}
                >
                  <div className="p-1 rounded absolute left-2">
                    <input
                      type="checkbox"
                      checked={checkedHasUSers(patient)}
                      onChange={(e) => handleChange(patient?.user_id, e)}
                      class="h-4 w-4 text-white bg-green-500 "
                    />
                  </div>
                  <div className="p-2">
                    <RP_Avatar
                      avatar={patient?.avatar}
                      size={20}
                      alt={` ${patient?.full_name}`}
                    />
                    <span>{patient?.full_name}</span>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <UploadDocumenten
        setRefresh={setRefresh}
        attachments={attachments}
        user={userdetails}
        type={type}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default PlansAdmin;
